import { render, staticRenderFns } from "./historyContract.vue?vue&type=template&id=eb4c74b2&scoped=true"
import script from "./historyContract.vue?vue&type=script&lang=js"
export * from "./historyContract.vue?vue&type=script&lang=js"
import style0 from "./historyContract.vue?vue&type=style&index=0&id=eb4c74b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4c74b2",
  null
  
)

export default component.exports